import * as React from "react";

import { useDialog } from "@shared-ui/dialog-context";

import { PropertySummary as SharedUiPropertySummary, PropertyMap } from "@shared-ui/lodging-property-details";

import { PropertyFilteredReviewsDialog } from "components/shared/PropertyFilteredReviewsDialog/PropertyFilteredReviewsDialog";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

const WrappedSummary = PropertyBexApiWrapper(SharedUiPropertySummary);
const WrappedPropertyMap = PropertyBexApiWrapper(PropertyMap);

export const PropertySummary: React.FC<ComponentProps> = ({ context, flexTemplateNode }) => {
  const id = flexTemplateNode?.id || "";

  const [, reviewsDialogActions, ReviewsDialogComponent] = useDialog(`summary-reviews-${id}`);
  const [, mapDialogActions, MapDialogComponent] = useDialog(`summary-map-${id}`);
  const triggerRef = React.useRef<HTMLElement>(null);

  /* istanbul ignore next */
  const onClickReviews = reviewsDialogActions.openDialog;
  /* istanbul ignore next */
  const onClickMap = mapDialogActions.openDialog;

  return (
    <>
      <WrappedSummary context={context} onClickMap={onClickMap} onClickReviews={onClickReviews} />
      <ReviewsDialogComponent>
        <PropertyFilteredReviewsDialog context={context} onClose={reviewsDialogActions.closeDialog} />
      </ReviewsDialogComponent>
      <MapDialogComponent>
        <WrappedPropertyMap context={context} onClose={mapDialogActions.closeDialog} triggerRef={triggerRef} />
      </MapDialogComponent>
    </>
  );
};
export default PropertySummary;
